import { createApp } from 'vue'
import App from './App.vue'
import router from './router/routes'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import VueCookies from 'vue-cookies'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/css/sweetalert-mobile.css'
import './assets/css/sweetalert-custom.css'
// Importar fuente Inter de Google Fonts
import '@fontsource/inter'
import '@fontsource/inter/300.css' // Light
import '@fontsource/inter/300-italic.css' // Light Italic
import '@fontsource/inter/400.css' // Regular
import '@fontsource/inter/500.css' // Medium
import '@fontsource/inter/700.css' // Bold
// Importar estilos globales
import './assets/styles/global.scss'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faLock, faSignOutAlt, faBars, faBell, faHome, faHistory, faWallet, faMapMarkerAlt, faArrowLeft, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import Swal from 'sweetalert2'
// OneSignal ha sido eliminado
import moment from 'moment'

// Add FontAwesome icons
library.add(faUser, faLock, faSignOutAlt, faBars, faBell, faHome, faHistory, faWallet, faMapMarkerAlt, faArrowLeft, faCheck, faTimes, faWhatsapp)

// Verificar si hay datos de autenticación en localStorage y sincronizar con cookies si es necesario
const syncAuthData = () => {
  const accessToken = localStorage.getItem('access_token')
  const id = localStorage.getItem('id')
  const email = localStorage.getItem('email')
  const expiresAt = localStorage.getItem('expires_at')
  
  if (accessToken && expiresAt) {
    // Verificar si el token ha expirado
    const now = moment()
    const expiration = moment(expiresAt)
    
    if (now.isBefore(expiration)) {
      // Token válido, sincronizar con cookies si no existen
      if (!Cookies.get('access_token')) {
        const expiresAtDate = new Date(expiresAt)
        Cookies.set('access_token', accessToken, { expires: expiresAtDate })
        if (id) Cookies.set('id', id, { expires: expiresAtDate })
        if (email) Cookies.set('email', email, { expires: expiresAtDate })
      }
      
      // Configurar Axios con el token
      axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken
    } else {
      // Token expirado, limpiar localStorage
      localStorage.removeItem('access_token')
      localStorage.removeItem('id')
      localStorage.removeItem('email')
      localStorage.removeItem('expires_at')
    }
  }
}

// Ejecutar sincronización al iniciar
syncAuthData()

const app = createApp(App)

// La configuración de OneSignal ha sido eliminada

// Inicializar el servicio de notificaciones después de montar la aplicación
app.config.globalProperties.$axios = axios;

// El método de verificación de notificaciones ha sido eliminado

// Interceptor para las solicitudes
axios.interceptors.request.use(
    function(config) {
      config["headers"] = {
        Authorization: "Bearer " + Cookies.get("access_token"),
        tokentap:'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
        Accept: "application/json"
      };
      config["onUploadProgress"] = progressEvent => {
       /* store.dispatch(
          "update_upload_percentage",
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        );*/
      };
  
      return config;
    },
    error => Promise.reject(error)
);

// Variable para controlar redirecciones
let isRedirecting = false;

// Interceptor para las respuestas
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Manejo de errores comunes como 401, 403, 500, etc.
    if (error.response && error.response.status === 401 && !isRedirecting) {
      // Prevenir múltiples redirecciones
      isRedirecting = true;
      
      // Limpiar todos los datos de autenticación
      Cookies.remove('access_token');
      Cookies.remove('id');
      Cookies.remove('email');
      localStorage.removeItem('access_token');
      localStorage.removeItem('id');
      localStorage.removeItem('email');
      localStorage.removeItem('expires_at');
      
      // Limpiar el header de autorización
      delete axios.defaults.headers.common["Authorization"];
      
      // Si ya estamos en login, no mostrar el alert ni redirigir
      if (window.location.pathname !== '/login') {
        // Mostrar SweetAlert antes de redirigir
        Swal.fire({
          title: 'Sesión expirada',
          text: 'Serás redirigido a el login',
          icon: 'warning',
          confirmButtonText: 'Aceptar',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/login';
        });
      }
      
      return new Promise(() => {});
    }
    
    return Promise.reject(error);
  }
);

app.config.globalProperties.$cookies = Cookies;

app.component('font-awesome-icon', FontAwesomeIcon)

// Configurar Axios globalmente (si aún no está hecho)
// TODO: Mover esto a un archivo de configuración si es necesario
app.config.globalProperties.$axios.defaults.baseURL = 'https://tu-api.com/api';

// La inicialización del plugin de OneSignal ha sido eliminada

app.use(router)
app.use(store)
app.use(VueCookies)

// Montar la aplicación
app.mount('#app')
